import { oc } from 'ts-optchain';
import { RootState } from 'store/types';
import { AddressValues } from 'screens/Profile/EditAddress';
import { BasicInfoForm, HouseholdForm, AssetsForm, BillsForm, CompleteForm } from './types';

export const faBasicInfoSelector = (state: RootState): BasicInfoForm | {} =>
  state.financialAssistance.basicInfo;

export const faHouseholdSelector = (state: RootState): HouseholdForm | {} =>
  state.financialAssistance.household;

export const faAssetsSelector = (state: RootState): AssetsForm | {} =>
  state.financialAssistance.assets;

export const faBillsSelector = (state: RootState): BillsForm | {} =>
  state.financialAssistance.bills;

export const faCompleteSelector = (state: RootState): CompleteForm | {} =>
  state.financialAssistance.complete;

export const faSubmitSendingSelector = (state: RootState): boolean =>
  oc(state).financialAssistance.submitFAForm.isSending(false);

export const isEditingFAProfileSelector = (state: RootState): boolean =>
  oc(state).financialAssistance.updateFAProfile.isEditingFAProfile(false);

export const updateFAProfileAddressSelector = (state: RootState): AddressValues | {} =>
  oc(state).financialAssistance.updateFAProfile.address({});
